// todo: refactor
const API_ROUTE_ROOT = 'manager'

export const API_ROUTE_USER_FROM_TOKEN = `${API_ROUTE_ROOT}/token/validate`

export const API_ROUTE_DASHBOARD_STATUS = 'status'

export const API_ROUTE_SYSTEM_MESSAGES = `${API_ROUTE_ROOT}/system-messages`

export const API_ROUTE_SUBSCRIPTION_LIST = `${API_ROUTE_ROOT}/subscriptions`
export const API_ROUTE_SUBSCRIPTION_SETUP = `${API_ROUTE_SUBSCRIPTION_LIST}/setup`
export const API_ROUTE_SUBSCRIPTION = `${API_ROUTE_ROOT}/subscriptions/:subscriptionId`
export const API_ROUTE_SUBSCRIPTION_RESEND_FORM = `${API_ROUTE_SUBSCRIPTION}/resend-form`

export const API_ROUTE_TERMINATION_LIST = `${API_ROUTE_ROOT}/terminations`
export const API_ROUTE_TERMINATION = `${API_ROUTE_TERMINATION_LIST}/:terminationOrderId`
export const API_ROUTE_TERMINATION_SETUP = `${API_ROUTE_TERMINATION_LIST}/setup`

export const API_ROUTE_SHOP = `${API_ROUTE_ROOT}/shop`
export const API_ROUTE_SHOP_SETUP = `${API_ROUTE_SHOP}/setup`
export const API_ROUTE_SHOP_ADDRESSES_SETUP = `${API_ROUTE_SHOP_SETUP}/addresses/:id`

export const API_ROUTE_DOCUMENTS = `${API_ROUTE_ROOT}/documents`
export const API_ROUTE_DOCUMENT = `${API_ROUTE_DOCUMENTS}/:id`

export const API_ROUTE_COST_OBJECTS = `${API_ROUTE_ROOT}/cost-objects`

// ECOM-POLICY
export const API_ROUTE_ECOM_POLICY = `${API_ROUTE_ROOT}/ecom-policy`
export const API_ROUTE_ECOM_POLICY_DETAILS = `${API_ROUTE_ECOM_POLICY}/:ecomPolicyId`
export const API_ROUTE_ECOM_POLICY_PRODUCTS = `${API_ROUTE_ECOM_POLICY_DETAILS}/products`
export const API_ROUTE_ECOM_POLICY_CUSTOMERS = `${API_ROUTE_ECOM_POLICY}/customers`
export const API_ROUTE_ECOM_POLICY_VENDORS = `${API_ROUTE_ECOM_POLICY}/customer-head/:customerHeadId/vendor-list`
export const API_ROUTE_ECOM_POLICY_ORDER_LIST = `${API_ROUTE_ECOM_POLICY}/orders`
export const API_ROUTE_ECOM_POLICY_ORDER = `${API_ROUTE_ECOM_POLICY_ORDER_LIST}/:orderId`
export const API_ROUTE_ECOM_POLICY_ORDER_STATUS = `${API_ROUTE_ECOM_POLICY_ORDER}/status`
export const API_ROUTE_ECOM_POLICY_ORDER_IGNORE = `${API_ROUTE_ECOM_POLICY_ORDER}/ignore`
export const API_ROUTE_ECOM_POLICY_ORDER_DOWN_PAYMENTS = `${API_ROUTE_ECOM_POLICY_ORDER}/down-payments/delete`
export const API_ROUTE_ECOM_POLICY_ORDER_ADD_DOWN_PAYMENT = `${API_ROUTE_ECOM_POLICY}/down-payment/:downPaymentId`
export const API_ROUTE_ECOM_POLICY_DELETE_ORDER_DOWN_PAYMENT = `${API_ROUTE_ECOM_POLICY}/down-payment/:downPaymentId/delete`
export const API_ROUTE_ECOM_POLICY_CUSTOMER_DEPARTMENTS = `${API_ROUTE_ECOM_POLICY}/customers/:customerId/departments`
export const API_ROUTE_ECOM_POLICY_PRICE_LIST = `${API_ROUTE_ECOM_POLICY}/:policyId/price-list`
export const API_ROUTE_ECOM_POLICY_PRICE_LIST_FOR_WHOLE_VENDOR_CATALOGUE = `${API_ROUTE_ECOM_POLICY}/:policyId/price-list/all`
export const API_ROUTE_ECOM_POLICY_ORDERS = `${API_ROUTE_ECOM_POLICY}/orders`
export const API_ROUTE_ECOM_PRODUCT_GROUPS = `${API_ROUTE_ECOM_POLICY}/product-groups`

export const API_ROUTE_TRANSLATIONS = 'translations/manager'
export const API_ROUTE_TRANSLATION = `${API_ROUTE_ROOT}/admin/translation`

// ADMIN
export const API_ROUTE_ADMIN = `${API_ROUTE_ROOT}/admin`
export const API_ROUTE_ADMIN_COST_OBJECTS = `${API_ROUTE_ADMIN}/cost-objects`
export const API_ROUTE_ADMIN_COST_OBJECT = `${API_ROUTE_ADMIN_COST_OBJECTS}/:costObjectId`
export const API_ROUTE_ADMIN_COST_OBJECT_SWITCH_NUMBER_TO_COMPANY = `${API_ROUTE_ADMIN_COST_OBJECT}/switch-to-company-number`
export const API_ROUTE_COST_OBJECTS_ASSIGN_ECOM_POLICIES = `${API_ROUTE_ADMIN_COST_OBJECTS}/assign/ecom-policies`
export const API_ROUTE_ADMIN_COST_OBJECT_APP_AWARENESS_MESSAGE = `${API_ROUTE_ADMIN_COST_OBJECT}/app-awareness-message`
export const API_ROUTE_ADMIN_COST_OBJECT_AWARENESS_EMAIL = `${API_ROUTE_ADMIN_COST_OBJECT}/awareness-mail`
export const API_ROUTE_ADMIN_COST_OBJECT_APP_PASSWORD = `${API_ROUTE_ADMIN_COST_OBJECT}/app-password`
export const API_ROUTE_ADMIN_COST_OBJECT_POLICY_SUBSCRIPTION = `${API_ROUTE_ADMIN_COST_OBJECTS}/:costObjectId/ecom-policy/:policyId`
export const API_ROUTE_ADMIN_COST_OBJECT_POLICY_SUBSCRIPTION_REMOVE = `${API_ROUTE_ADMIN_COST_OBJECTS}/:costObjectId/ecom-policy/:policyId/remove`
export const API_ROUTE_ADMIN_COST_OBJECT_POLICY_SUBSCRIPTION_UNLOCK_ORDERING = `${API_ROUTE_ADMIN_COST_OBJECTS}/:costObjectId/ecom-policy/:policyId/unlock`
export const API_ROUTE_ADMIN_ASSETS = `${API_ROUTE_ADMIN}/assets`
export const API_ROUTE_ADMIN_ASSETS_LEASED = `${API_ROUTE_ADMIN}/assets/leased`
export const API_ROUTE_ADMIN_ASSET = `${API_ROUTE_ADMIN}/assets/:assetId`
export const API_ROUTE_ADMIN_ASSET_TYPES = `${API_ROUTE_ADMIN}/assets/types`
export const API_ROUTE_ADMIN_TRANSLATION = `${API_ROUTE_ADMIN}/translation`
export const API_ROUTE_ADMIN_USERS_LEGACY = 'manager/admin/users'
export const API_ROUTE_ADMIN_ASSET_LOCATION_LIST = `${API_ROUTE_ADMIN}/asset-locations`
export const API_ROUTE_ADMIN_ASSET_LOCATION = `${API_ROUTE_ADMIN}/asset-locations/:costObjectId`
/**
 * New admin backend apis
 */
export const API_ROUTE_ADMIN_TEXT_TEMPLATES = 'text-templates'
export const API_ROUTE_ADMIN_WHITE_LABELS = 'whitelabels'
export const API_ROUTE_ADMIN_TEXT_TEMPLATE_CODES = 'text-templates/codes'
export const API_ROUTE_ADMIN_AUTH = 'auth'
export const API_ROUTE_ADMIN_USERS = 'users'
export const API_ROUTE_ADMIN_USER = 'users/:userId'
export const API_ROUTE_ADMIN_USER_GENERATE_PASSWORD = `${API_ROUTE_ADMIN_USER}/generate-password`
export const API_ROUTE_ADMIN_CUSTOMER_ADDRESSES = 'addresses'
export const API_ROUTE_ADMIN_CUSTOMER_ADDRESSES_BY_ID = 'addresses/:id'
// ADMIN DEPARTMENTS
export const API_ROUTE_ADMIN_DEPARTMENTS = 'departments'
export const API_ROUTE_ADMIN_DEPARTMENT = `${API_ROUTE_ADMIN_DEPARTMENTS}/:departmentId`
export const API_ROUTE_DEPARTMENT_HEAD = `${API_ROUTE_ADMIN_DEPARTMENT}/head`
// ADMIN PHONE
export const API_ROUTE_ADMIN_PHONE = 'phone'
export const API_ROUTE_ADMIN_USES_ALIASES = `${API_ROUTE_ADMIN_PHONE}/aliases`
export const API_ROUTE_ADMIN_PHONE_SEND_SMS = `${API_ROUTE_ADMIN_PHONE}/send-sms`
export const API_ROUTE_ADMIN_PHONE_ACTIVE_NUMBERS_LIST = `${API_ROUTE_ADMIN_PHONE}/numbers`
export const API_ROUTE_ADMIN_PHONE_GROUP_NUMBERS_LIST = `${API_ROUTE_ADMIN_PHONE}/group-numbers`
// ADMIN PHONE LOGS
export const API_ROUTE_ADMIN_PHONE_SMS_LOGS = `${API_ROUTE_ADMIN_PHONE}/sms-logs`
export const API_ROUTE_ADMIN_PHONE_SMS_LOGS_BY_BATCH = `${API_ROUTE_ADMIN_PHONE_SMS_LOGS}/:batchId`
// ADMIN PHONE GROUPS
export const API_ROUTE_ADMIN_PHONE_GROUPS = `${API_ROUTE_ADMIN_PHONE}/groups`
export const API_ROUTE_ADMIN_PHONE_GROUP = `${API_ROUTE_ADMIN_PHONE_GROUPS}/:groupId`
export const API_ROUTE_ADMIN_PHONE_GROUP_NUMBERS = `${API_ROUTE_ADMIN_PHONE_GROUP}/numbers`
export const API_ROUTE_ADMIN_PHONE_GROUP_NUMBER = `${API_ROUTE_ADMIN_PHONE_GROUP_NUMBERS}/:numberId`
// ADMIN PHONE BOOKS
export const API_ROUTE_ADMIN_PHONE_BOOKS = `${API_ROUTE_ADMIN_PHONE}/books`
export const API_ROUTE_ADMIN_PHONE_BOOKS_UPDATE_NUMBER = `${API_ROUTE_ADMIN_PHONE_BOOKS}/:id`
// ADMIN INVOICES
export const API_ROUTE_ADMIN_INVOICES = 'invoices'
export const API_ROUTE_ADMIN_VENDOR_INVOICES = `${API_ROUTE_ADMIN_INVOICES}/vendor`
export const API_ROUTE_ADMIN_INVOICE = `${API_ROUTE_ADMIN_INVOICES}/:invoiceId`
// ADMIN TELE POLICIES
export const API_ROUTE_ADMIN_TELE_POLICIES = 'tele-policies'
export const API_ROUTE_ADMIN_TELE_POLICY = `${API_ROUTE_ADMIN_TELE_POLICIES}/:id`
export const API_ROUTE_ADMIN_TELE_POLICY_TEMPLATES = `${API_ROUTE_ADMIN_TELE_POLICIES}/templates`
export const API_ROUTE_COST_OBJECTS_ASSIGN_TELE_POLICIES = `${API_ROUTE_ADMIN_TELE_POLICIES}/assign`

export const API_ROUTE_ADMIN_EMPLOYEE_CONSENTS = 'employee-consent'
export const API_ROUTE_ADMIN_EMPLOYEE_CONSENT_DETAILS = 'employee-consent/:consentId'
export const API_ROUTE_ADMIN_EMPLOYEE_CONSENT_REPORT = 'employee-consent/:consentId/report'
export const API_ROUTE_ADMIN_EMPLOYEE_CONSENT_COST_OBJECT_HISTORY =
  'employee-consent/:consentId/cost-object/:costObjectId'
export const API_ROUTE_ADMIN_EMPLOYEE_CONSENT_PUBLISH = 'employee-consent/:consentId/publish'

export const API_ROUTE_ADMIN_EMPLOYEE_CONSENTS_REVOKE = `${API_ROUTE_ADMIN_EMPLOYEE_CONSENTS}/:consentId/revoke/:costObjectId`
export const API_ROUTE_ADMIN_REPORTS = 'reports'
export const API_ROUTE_ADMIN_REPORTS_CUSTOMERS = `${API_ROUTE_ADMIN_REPORTS}/customers`
export const API_ROUTE_ADMIN_REPORTS_SETUP_EXPORT = `${API_ROUTE_ADMIN_REPORTS}/setup-export-settings`
export const API_ROUTE_ADMIN_REPORTS_CUSTOER_SPECIFIC = `${API_ROUTE_ADMIN_REPORTS}/customer-specific`

export const API_ROUTE_ADMIN_EXPORTS = 'exports/generate'

export const API_ROUTE_ADMIN_ASSETS_NEW = 'assets'

// SUBSCRIPTIONS - NEW API
export const API_ROUTE_SUBSCRIPTIONS = 'subscriptions'
export const API_ROUTE_SUBSCRIPTION_SHOW = `${API_ROUTE_SUBSCRIPTIONS}/:subscriptionId`
export const API_ROUTE_ONBOARDING_CANCEL = `${API_ROUTE_SUBSCRIPTIONS}/onboarding/:subscriptionId/cancel`
export const API_ROUTE_TERMINATION_CANCEL = `${API_ROUTE_SUBSCRIPTIONS}/termination/:subscriptionId/cancel`

// ADMIN FEATURES
export const API_ROUTE_ADMIN_FEATURE_LIST = 'features'
export const API_ROUTE_ADMIN_FEATURE_ACTIVE_CUSTOMERS = 'features/:featureName/customers'
export const API_ROUTE_ADMIN_FEATURE_DETAILS = 'features/:featureId'
export const API_ROUTE_ADMIN_FEATURE_ACTIVITIES = 'features/:featureId/activities'
export const API_ROUTE_ADMIN_FEATURE_SALES_PITCH = 'features/:featureId/sales-pitch'
export const API_ROUTE_ADMIN_FEATURE_TERM_OF_SERVICE = 'features/:featureId/term-of-service'
export const API_ROUTE_ADMIN_ACTIVATE_FEATURE = 'features/:featureId/activate'
export const API_ROUTE_ADMIN_DEACTIVATE_FEATURE = 'features/:featureId/deactivate'

// DRILL DOWN
export const API_ROUTE_ADMIN_DRILL_DOWN = `${API_ROUTE_ROOT}/drill-down`
export const API_ROUTE_ADMIN_DRILL_DOWN_TOTAL = `${API_ROUTE_ADMIN_DRILL_DOWN}/total/:year/:period`
export const API_ROUTE_ADMIN_DRILL_DOWN_CATEGORIES = `${API_ROUTE_ADMIN_DRILL_DOWN}/:type/:typeId/:year/:period`
export const API_ROUTE_ADMIN_DRILL_DOWN_GROUPS = `${API_ROUTE_ADMIN_DRILL_DOWN_CATEGORIES}/categories/:categoryId`
export const API_ROUTE_ADMIN_DRILL_DOWN_PRODUCTS = `${API_ROUTE_ADMIN_DRILL_DOWN_GROUPS}/groups/:groupId`
// DRILL DOWN - NEW API
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN = `drill-down`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_TOTAL = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/total/:year/:period`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_TOTAL_QS = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/total`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/service`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE_CATEGORY = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/service/category`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE_CATEGORY_GROUPS = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/service/category/groups`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE_CATEGORY_GROUPS_COST_OBJECTS = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/service/category/groups/cost-objects`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_DEPARTMENT = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/department`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_DEPARTMENT_COST_OBJECTS = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/department/cost-objects`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_DEPARTMENT_COST_OBJECTS_PRODUCTS = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/department/cost-objects/products`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_COST_OBJECT = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/cost-object`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_COST_OBJECT_PRODUCTS = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/cost-object/products`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_CATEGORIES = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN}/:type/:typeId/:year/:period`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_GROUPS = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_CATEGORIES}/categories/:categoryId`
export const NEW_API_ROUTE_ADMIN_DRILL_DOWN_PRODUCTS = `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_GROUPS}/groups/:groupId`

// ECOM-POLICY
export const API_ROUTE_ECOM_POLICY_UPDATE_CATEGORY_CLASSIFICATION = `ecom-policy/category-classification/:id`

// TRADE-IN
export const API_ROUTE_TRADE_IN = `tradein`
export const API_ROUTE_TRADE_IN_ACTIVATE = `${API_ROUTE_TRADE_IN}/activate/:customerId`
export const API_ROUTE_TRADE_IN_ORDERS = `${API_ROUTE_TRADE_IN}/orders`
export const API_ROUTE_TRADE_IN_ORDER_HISTORY = `${API_ROUTE_TRADE_IN}/orders/:orderId/history`
export const API_ROUTE_TRADE_IN_ORDER_STATUS = `${API_ROUTE_TRADE_IN}/orders/:orderId/status`
export const API_ROUTE_TRADE_IN_ASSET_ORDER = `${API_ROUTE_TRADE_IN}/assets/:assetId/order`
export const API_ROUTE_TRADE_IN_CUSTOMER_AGREEMENTS = `${API_ROUTE_TRADE_IN}/agreements/:customerId`
export const API_ROUTE_TRADE_IN_AGREEMENTS = `${API_ROUTE_TRADE_IN}/agreements/:customerId`

// ASSET-LOCATIONS
export const API_ROUTE_ADMIN_LOCATIONS = 'locations'
export const API_ROUTE_ADMIN_LOCATIONS_DETAILS = 'locations/:costObjectId'

// LEASING
export const API_ROUTE_LEASING = 'leasing'
export const API_ROUTE_LEASING_END_OF_LEASE = `${API_ROUTE_LEASING}/endoflease`
export const API_ROUTE_LEASING_END_OF_LEASE_VALIDATE = `${API_ROUTE_LEASING_END_OF_LEASE}/validate`
export const API_ROUTE_LEASING_EXTEND = `${API_ROUTE_LEASING}/extend`
export const API_ROUTE_LEASING_EXTEND_VALIDATE = `${API_ROUTE_LEASING_EXTEND}/validate`
export const API_ROUTE_LEASING_RETURN = `${API_ROUTE_LEASING}/return`
export const API_ROUTE_LEASING_RETURN_VALIDATE = `${API_ROUTE_LEASING_RETURN}/validate`
export const API_ROUTE_LEASING_END_COUNT = `${API_ROUTE_LEASING}/end/count`
export const API_ROUTE_LEASING_VENDORS = `${API_ROUTE_LEASING}/vendors`
export const API_ROUTE_LEASING_CUSTOMER_VENDORS = `${API_ROUTE_LEASING}/customers/:id/vendors`
export const API_ROUTE_LEASING_ASSETS_DETAILS = `${API_ROUTE_LEASING}/assets/:id`

// CARRIER
export const API_ROUTE_CARRIER = 'carrier'
export const API_ROUTE_CARRIER_BYID = `${API_ROUTE_CARRIER}/byid`
